import { FileRequest, UseLocalApiOptions } from "../types";

export const useFiles = ({ context }: UseLocalApiOptions) => ({
  open: (request: FileRequest) => {
    // eslint-disable-next-line no-alert
    alert(`Opening file:
      matter id: ${request.matterId || context?.matterId}
      file id: ${request.id}
    `);
  },
});
